import Config from '../../config';
import Collection from '../../collection';
import Field from '../../model/refbooks/field';
import Form from '../../view/form';
import RefBooksModule from "./refbooks.module";
import Type from '../../model/newstype';

import { roleC } from '../../roles';
import { error } from '../../ui/messages'
import { handle } from '../../service/messages';  
import { beginLock, endLock } from '../../loader';
import { hashify, keyset } from '../../utils/arrays';





const 
    OPEN_TYPE = 'type-form--popup',
    TOGGLE_BOUND_ORGANIZATIONS = 'type-form--toggle-bound-organizations',
    TOGGLE_BOUND_FIELDS = 'type-form--toggle-bound-fields',
    TOGGLE_BOUND_ROLES = 'type-form--toggle-bound-roles';





export default RefBooksModule.extend( {

    open({ type, original, bindings }) {
        this.options.type = type, this.original = original;
        this.options.bindings = bindings || { add: {}, update: {}, remove: {}, };

        const originalCluster = original
            ? original.get( 'cluster' )
            : null;

        if (!type.id)
            if (this.state().cluster && this.state().cluster.id != -1)
                type.set( 'cluster', this.state().cluster );
            else if (~roleC.indexOf( Config.role() ))
                type.set( 'cluster', Config.cluster() );

        // both views (Orgs & Roles) contain Grid -
        // so we can make preparation in their common parent
        this.options.sorted = new Collection();
        this.options.filtered = new Collection();
        this.options.resulted = new Collection();

        return this.finalizeOpen( type, { originalCluster } );
    },

    finalizeOpen(type, { originalCluster }) {
        const binding = this.reSortGrid()
            .then( () => this.reFilterGrid() )
            .then( () => this.bind( type ) )
            .then( () => this.originalModel.set( 'cluster', originalCluster ) )
            .then( () => this );
        return binding.view = this, binding;
    },

    onBind() {
        // rewrite originalModel with passed value
        this.originalModel = this.original || this.originalModel;
    },

    start() {
        this.listenTo( this.options.type, 'change:cluster', () => {
            this.setState( { page: 1, } ), this.navigated();
            this.reFilterGrid( this );

            const { type } = this.options;
            if (!type.get( 'group_id' ))
                return;

            const cluster = type.get( 'cluster' );
            const [typeGroup] = this.options.typeGroups.toJSON()
                    .filter( tg => tg.id == type.get( 'group_id' ) );

            if (!!cluster !== !!typeGroup.cluster)
                this.model.set( 'group_id', null );

            if (typeGroup.cluster)
                if (typeGroup.cluster.id != cluster.id)
                    this.model.set( 'group_id', null );
        } );
        this.listenTo( this.options.type, 'change',
            () => this.$( '.-save' )[0].disabled = !this.hasDiff() );

        return this;
    },

    stop() {
        return this.stopListening( this.options.type ), this;
    },

    serialize() {
        const { typeGroups, clusters, } = this.options;

        const typeGroupsFn = () => typeGroups
            .toJSON()
            .filter( tg => !tg.cluster && !this.model.get( 'cluster' ) ||
                tg.cluster && this.model.get( 'cluster' ) &&
                    this.model.get( 'cluster' ).id == tg.cluster.id )
            .map( tg => ({ id: tg.id, title: tg.name }) );

        return {
            typeGroupsFn, clusters,
            hasDiff: () => this.hasDiff(),
        };
    },

    // copied from form.js
    diff(options = {}) {
        if (!this.model)
            return [];

        const diff = this.model.diff( this.originalModel, options );

        const { fields: fieldList, bindings: { add, update, remove } } = this.options;
        const fields = hashify( fieldList, field => [field.id, field] );

        const hasAddOrUpdate = keyset( add, update )
            .filter( id => !remove[id] )
            .map( id => add[id] || update[id] )
            .some( ({ field, ...binding }) => {
                if (!field.id || field.id < 0 && [false, 'f'].includes( field.system ))
                    return true;

                const originalField = new Field( fields[field.id] );
                const modifiedField = new Field( field );
                const di = originalField.diff( modifiedField )
                    .filter( d => d.attrName != 'bindings' );
                if (di.length > 0)
                    return true;

                // non-new non-system field
                if (field.id && field.id > 0)
                    // just added
                    if (add[field.id])
                        // non for-all
                        if ([false, 'f'].includes( field.is_for_all ))
                            // added via "Choose field" - and this addition counts as modification of Type
                            return true;

                // no change in binding at all
                if (binding.on == undefined && binding.rules == undefined)
                    return false;

                // exclude "type": no type in here-field-binding
                const { type, ...originalBinding } = originalField.get( 'bindings' )
                    .find( b => b.type.id == this.model.id )
                    ||
                    {
                        on: ['f', false].includes( field.is_for_all ),
                        visible_by_default: true,
                        visible_inverted_for_roles: [],
                    };
                const a = JSON.stringify( Field.normalizeBinding( binding ) );
                const b = JSON.stringify( Field.normalizeBinding( originalBinding ) );

                return a !== b;
            } );

        const hasRemove = Object.values( fields )
            .filter( f => remove[f.id] )
            .some( f => f.bindings
                .find( b => 
                    b.type.id == this.options.type.id &&
                    [true, 't'].includes( b.on ) ) );

        if (hasAddOrUpdate || hasRemove)
            return [...diff, { attrName: 'bindings' }];

        return diff;
    },

    hasDiff(options = {}) {
        return this.diff( options ).length > 0;
    },

    events: {

        'click .-save'() {
            // cluster may be set only at create
            if (!this.model.id)
                if (this.model.get( 'cluster' )) {
                    const clusterId = this.model.get( 'cluster' ).id;
                    const clusterIds = hashify( this.options.organizations,
                        org => [org.id, org.cluster_id] );

                    this.model.set( 'departments', this.model.get( 'departments' )
                        .filter( orgId => clusterId == clusterIds[orgId] ) );
                };

            const onReject = message => {
                endLock( this );
                handle( this, error( message ) );
            };

            beginLock( this );

            // dirty hack to force types.save() to invoke save(view) in actions.js
            const stubView = new Form();
            stubView.model = new Type( this.model.adjusted( this.originalModel, this.options ) );
            stubView.originalModel = this.originalModel;

            return this.options.types.save( stubView )
                .then( ({ fields, ...attrs }) => {
                    if (!fields || !fields.length)
                        return;

                    // todo better
                    const parsed = fields.map( attrs => new Field().parse( attrs ) );
                    this.options.fields.add( 
                        parsed, { merge: true } );
                } )
                .then( 
                    (/* type */) => this.trigger( RefBooksModule.BACK ), 
                    onReject );
        },

        'click .-close'() {
            this.trigger( RefBooksModule.BACK );
        },

    },

    [RefBooksModule.event(':bound-organizations:toggle')]() {
        this.trigger( TOGGLE_BOUND_ORGANIZATIONS,
            this.model,
            this.originalModel,
            this.options.bindings,
            this.state() );
    },

    [RefBooksModule.event(':bound-fields:toggle')]() {
        this.trigger( TOGGLE_BOUND_FIELDS,
            this.model,
            this.originalModel,
            this.options.bindings,
            this.state() );
    },

    [RefBooksModule.event(':bound-roles:toggle')]() {
        this.trigger( TOGGLE_BOUND_ROLES,
            this.model,
            this.originalModel,
            this.options.bindings,
            this.state() );
    },

}, {

    OPEN_TYPE,

    TOGGLE_BOUND_ORGANIZATIONS,

    TOGGLE_BOUND_FIELDS,

    TOGGLE_BOUND_ROLES,

} );



// WEBPACK FOOTER //
// ./src/js/module/refbooks/types.form.template.js